
const CssStyles = {
    motionDivInitial: { opacity: 0, x: -100 },
    motionDivAnimate: { opacity: 1, x: 0 },
    motionDivExit: { opacity: 0, x: -100 },
}


export default CssStyles;